module.exports = __webpack_public_path__ + "img/31e90.7fc5f1c0.png";